/**
 * The stores that hold data of the API (customers, contacts, e-mail addresses, product keys). They are kept in
 * memory only; older versions kept them in the localStorage, where they stayed after the logout and could be shown
 * to the next user of the browser.
 */
const apiDataStores = ['profile', 'customers', 'instances', 'contacts', 'deputies']

/**
 * Removes what older versions left in the localStorage. Called at the start of the app.
 *
 * @returns {undefined}
 */
export function removeStoredApiData () {
  for (const id of apiDataStores) {
    try {
      localStorage.removeItem(id)
    } catch (error) {
      // No localStorage (e.g. blocked by the browser): nothing was stored either
    }
  }
}

/**
 * Forgets all data of the logged in user: every store is reset. Called before the logout.
 *
 * @param {import('pinia').Pinia} pinia
 * @returns {undefined}
 */
export function clearSessionData (pinia) {
  // pinia keeps its stores in _s; there is no public list of them
  for (const store of pinia._s.values()) {
    store.$reset()
  }

  removeStoredApiData()
}
